import { createContext } from 'react'
import BookTrial from './types/Book'
import UserInfo from './types/UserInfo'

export const BookContext = createContext<BookTrial | null>(null)

// export const UserInfoContext = createContext<UserInfo>(null)
export const UserInfoContext = createContext<UserInfo | null>(null)
